import React, { useEffect, useState } from "react";
import Actions from "../Actions/Actions";
import { BsBoxArrowLeft, BsBoxArrowRight } from "react-icons/bs";
import LeftSectionBar from "../LeftSectionBar/LeftSectionBar";
import FilterSection from "../FilterSection/FilterSection";
import Table from "../Table/Table";
import { applyFilter } from "../../utils/filter";
import "./CatalogueDataSection.scss";
import { useDispatch, useSelector } from "react-redux";
import { _ } from "gridjs-react";
import Tooltip from "../Tooltip/Tooltip";
import { breadcrumbNodesUpdated, selectedSPWUpdated } from "../../redux/reducer";
import { BASE_BREADCRUMB_NODE, CATALOGUE_NODE } from "../../constants";
import { formatData, checkIfEmpty, checkIfExistsAndNotEmpty, isEmptyString } from "../../helperFunc";
import { useLocation, useSearchParams } from "react-router-dom";

function CatalogueDataSection({ data, navigateSourceTo, gaussDownloadPost={} }) {
  const [filterCollapsed, setFilterCollapsed] = useState(false);
  const { filters } = useSelector((state) => state.router);
  const dispatch = useDispatch();
  function filterData(filters) {
    const results = applyFilter(catalogue, filters);
    setDisplayCatalogueData(results);
  }
  const { selectedSPW } = useSelector((state) => state.router);
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();

  useEffect(() => {
    const spwId = searchParams.get("spw");
    if (!spwId) return;
    dispatch(selectedSPWUpdated({ selectedSPW: spwId }));
    const isValidSelectedSpw =
      !spwId && selectedSPW !== "ALL" && checkIfExistsAndNotEmpty(selectedSPW);
    // if (isValidSelectedSpw) setSearchParams({ spw: selectedSPW }, { replace: true, state: { internalNavigation: location?.state?.internalNavigation ,pointingsRefreshed:!location?.state?.internalNavigation } });
  }, [selectedSPW]);

  const {
    catalogue,
    column_description,
    column_map,
    hidden_columns,
    column_order,
  } = data || {
    catalogue: [],
    column_description: [],
    column_map: {},
    column_order: [],
    hidden_columns: [],
  };
  const [displayCatalogueData, setDisplayCatalogueData] = useState(catalogue);
  function displayAllData() {
    setDisplayCatalogueData(catalogue);
  }
  function navigateToSourceDetail(rowClickEvent) {
    const [event, rowData] = rowClickEvent;
    const urlId =
      rowData._cells[columns.findIndex((el) => el.id === "url_id")].data;
    dispatch(
      breadcrumbNodesUpdated({
        breadcrumbNodes: [
          ...BASE_BREADCRUMB_NODE,
          ...CATALOGUE_NODE,
          {
            absolute_path: "",
            label: "Source Detail",
          },
        ],
      })
    );
    navigateSourceTo(urlId);
  }

  useEffect(() => {
    if (!checkIfEmpty(filters)) filterData(filters);
  }, [filters]);

  const columns = column_order?.map((key, index) => {
    return {
      id: key,
      name: _(
        <Tooltip isPopover={false} tooltipForTableHeader={true}>
          <>
            <span>{column_map[key]?.text || key}</span>
            <br />
            {column_map[key] && !isEmptyString(column_map[key].unit) ? (
              <span className="table-unit">({column_map[key].unit})</span>
            ) : (
              <></>
            )}
          </>
          <>{column_description[key]}</>
        </Tooltip>
      ),
      formatter: (cell) => `${formatData(key, cell)}`,
      hidden: hidden_columns?.includes(key),
    };
  });

  useEffect(() => {
    if (!checkIfEmpty(filters)) {
      filterData(filters);
      return;
    }
    setDisplayCatalogueData(catalogue);
  }, [data]);

  return (
    <div
      className={`catalogue-container ${filterCollapsed ? "filter-collapsed-view" : ""
        }`}
    >
      <LeftSectionBar
        filterCollapsed={filterCollapsed}
        setFilterCollapsed={setFilterCollapsed}
      >
        <Actions 
         displayCatalogueData={displayCatalogueData} 
         gaussDownloadPost={gaussDownloadPost}
        />
        <button
          className="collapse-btn"
          onClick={() => setFilterCollapsed(!filterCollapsed)}
        >
          {filterCollapsed ? <BsBoxArrowRight /> : <BsBoxArrowLeft />}
        </button>

        <FilterSection
          totalDisplayedResults={displayCatalogueData?.length}
          filterCollapsed={filterCollapsed}
          removeFilterHandler={displayAllData}
          setFilterCollapsed={setFilterCollapsed}
        />
      </LeftSectionBar>

      <Table
        columns={columns}
        stickyFirstColumn={true}
        data={displayCatalogueData}
        pagination={{
          enabled: true,
          limit: 100,
        }}
        fixedHeader={true}
        sort={true}
        rowClickHandler={(rowClickEvent) =>
          navigateToSourceDetail(rowClickEvent)
        }
      />
    </div>
  );
}

export default CatalogueDataSection;
